import type { RouteLocationRaw } from "#vue-router";
import type {
  CourseListApiFilters,
  CourseListApiView,
} from "~~/model/course.model";

export type CourseListView = CourseListApiView & {
  _links: {
    page: RouteLocationRaw;
  };
};

export function toCourseListView(course: CourseListApiView): CourseListView {
  return {
    ...course,
    _links: {
      page: {
        name: "courses-slug",
        params: {
          slug: course.slug,
        },
      },
    },
  };
}

export const useCourseList = (
  key: string,
  filters?: CourseListApiFilters,
  options?: {
    server?: boolean;
    lazy?: boolean;
  },
) => {
  const courseCache = useCourseCache();

  const query = useFetch("/api/courses", {
    key,
    query: filters,
    watch: false,
    server: options?.server,
    lazy: options?.lazy,
    dedupe: "defer",
    default: () => [],
    transform(data) {
      const views: CourseListView[] = data.map((course) =>
        toCourseListView(course),
      );

      courseCache.setMultiple(views);

      return views;
    },
  });

  if (filters && isReactive(filters)) {
    /*
      Let's use a manual watch call here instead of using "watch" option on useAsyncData
      By default (and not customizable for now), the watcher set in useAsyncData has a flush "sync" setting
      probably due to the fact that in most cases, it expects a shallowRef and not a reactive object
      Given the fact that we have a date filters for which we may set synchronously from and to values
      we don't want those sync changes to trigger multiple requests
       */
    watch(filters, () => query.refresh());
  }

  return query;
};
